import type { CSSProperties } from 'react';

const frameStyle: CSSProperties = {
	width: '100%',
	height: '100vh',
	minHeight: 640,
	border: 0,
	display: 'block'
};

function DPPStudyScheduleVersion1() {
	return (
		<iframe
			title='DPP Study Schedule'
			src='/charts/DPP%20Study%20Schedule%20v1.html'
			style={frameStyle}
		/>
	);
}

export default DPPStudyScheduleVersion1;
